import React, { useState } from 'react';
import styled from 'styled-components';
import dayjs from 'dayjs';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { useTranslation } from 'react-i18next';
import i18n from '../../../i18n';
import 'dayjs/locale/pl';
import 'dayjs/locale/ru';
import 'dayjs/locale/uk';

const StyledStack = styled(Stack)`
  .MuiFormControl-root {
    margin: 0 0.5rem;
  }
`;

export default function BirthdayDate({ ...props }) {
  const [value, setValue] = useState(dayjs(new Date()));
  const { t } = useTranslation();

  const onChangeHandler = (date) => {
    props.onChange(date?.$d);
    setValue(date?.$d);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={i18n?.language}>
      <StyledStack
        spacing={3}
        sx={{
          '& .MuiFormControl-root': {
            marginTop: 0,
          },
          flexDirection: 'row',
          justifyContent: 'center',
          pt: 2,
        }}
      >
        <DatePicker
          views={['day']}
          label={t('birthdate_day_short')}
          value={value}
          openTo="day"
          onChange={onChangeHandler}
          renderInput={(params) => (
            <TextField
              {...params}
              helperText={null}
              sx={{
                '& .MuiInputBase-input': {
                  height: '0px',
                },
                width: '67px',
              }}
              inputProps={{
                ...params.inputProps,
                readOnly: true,
              }}
            />
          )}
          inputFormat="DD"
          components={{
            OpenPickerIcon: KeyboardArrowDownIcon,
          }}
          required
        />
        <DatePicker
          views={['month']}
          label={t('birthdate_month_short')}
          value={value}
          openTo="month"
          onChange={onChangeHandler}
          sx={{ marginTop: 0 }}
          renderInput={(params) => (
            <TextField
              {...params}
              helperText={null}
              sx={{
                '& .MuiInputBase-input': {
                  height: '0px',
                },
                width: '67px',
                marginRight: 0.5,
              }}
              inputProps={{
                ...params.inputProps,
                readOnly: true,
              }}
            />
          )}
          inputFormat="MM"
          components={{
            OpenPickerIcon: KeyboardArrowDownIcon,
          }}
        />
        <DatePicker
          views={['year']}
          label={t('birthdate_year_short')}
          value={value}
          openTo="year"
          onChange={onChangeHandler}
          renderInput={(params) => (
            <TextField
              {...params}
              helperText={null}
              sx={{
                '& .MuiInputBase-input': {
                  height: '0px',
                },
                width: '78px',
              }}
              inputProps={{
                ...params.inputProps,
                readOnly: true,
              }}
            />
          )}
          components={{
            OpenPickerIcon: KeyboardArrowDownIcon,
          }}
        />
      </StyledStack>
    </LocalizationProvider>
  );
}
